import { useDisclosure } from "@msuite/ui/hooks";
import { DataTable } from "@msuite/ui/table";
import type { BookingsReviewListItem } from "@msuite/utils/types";
import { useMemo, useState } from "react";
import { usePendingReviewBookings } from "@/hooks/use-pending-review-bookings";
import { AssignmentReferenceBookingsModal } from "@/modals/partners/assignment-reference-bookings-modal";
import { createColumns } from "./table-config";

/** The host's review queue: every partner record with booked hours nobody has answered yet. */
export function BookingReviews() {
	/** Hooks */
	const bookingsModal = useDisclosure();

	/** State */
	const [selected, setSelected] = useState<BookingsReviewListItem | null>(null);

	/** Query */
	const { bookings, isLoading, queryKey, refetch } = usePendingReviewBookings();

	/** Functions */
	function handleOnOpen(booking: BookingsReviewListItem) {
		setSelected(booking);
		bookingsModal.onOpen();
	}

	async function handleOnComplete() {
		await refetch();
	}

	/** Computed */
	const columns = useMemo(() => createColumns(handleOnOpen), []);

	/** Render */
	return (
		<>
			<DataTable
				data={bookings}
				isLoading={isLoading}
				columns={columns}
				menu={null}
				queryKey={queryKey}
				persistenceKey="partner-booking-reviews-table"
				refetch={refetch}
				initialPinningState={{ start: ["date"] }}
				initialSortingState={[{ id: "date", desc: false }]}
			/>
			{bookingsModal.isOpen && selected && (
				<AssignmentReferenceBookingsModal
					isOpen={bookingsModal.isOpen}
					onClose={bookingsModal.onClose}
					referenceId={selected.id}
					partnershipId={selected.partnershipId}
					date={selected.date}
					onComplete={handleOnComplete}
				/>
			)}
		</>
	);
}
